import { AssemblyAI } from "assemblyai";

const client = new AssemblyAI({
  apiKey: import.meta.env.VITE_ASSEMBLYAI_API_KEY,
});

export const useAssemblyAI = () => {
  return client;
};